module.exports = __webpack_public_path__ + "static/img/26825@2x.ee20c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/stockUniverse/26825@2x.png
// module id = Uy/F
// module chunks = 0